/**
 * Copyright (C) 2009 Fundación Centro Cultural Colombo Americano de Cali.
 *
 * Este archivo es parte de SOFI: "Software Organizacional Fácil e Inteligente".
 *
 * Este programa es software comercial: está prohibida la venta, distribución y modificación de
 * SOFI sin la autorización de la Fundacion Centro Cultural Colombo Americano de Cali.
 *
 * Este programa fue registrado bajo las leyes de registro mercantil y ley de derechos de autor en
 * la SIC: "Superintendencia de Industria y Comercio".
 *
 * Cualquier duda o información acerca del programa se debe enviar a info@colomboamericano.edu.co.
 */

// Dependencies
import React from 'react';
import { Droppable } from 'react-beautiful-dnd';

/**
 * Custom Droppable component.
 *
 * @author Daniel Mejia
 * @class CustomDroppable
 */
function CustomDroppable({ droppableId, className, style, children }) {
  return (
    <Droppable droppableId={droppableId}>
      {provided => (
        <div ref={provided.innerRef} style={style} className={className}>
          {children}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
}

export default CustomDroppable;
